angular.module('zc.projects')

.directive 'zcCampaignSegmentEditor', (CampaignSegment) ->
  templateUrl: '/templates/projects.segments/campaign_segment_editor.html'
  scope:
    project: "="
    campaignSegment: "="
    readOnly: "@"
  link: (scope, element, attrs) ->
    scope.CampaignSegment = CampaignSegment
    scope.CampaignSegment.checkZcRule(scope.campaignSegment)




// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.segments/campaign_segment_editor.directive.js.coffee